import type { IMultiAnalysisDataMark } from "../types";

export interface ITimePanelMarkPosition {
  mark: IMultiAnalysisDataMark;
  measureKey: string | null;
  x: number;
  tipY: number;
  baseY: number;
}

export interface ITimePanelMarkGroup {
  positions: ITimePanelMarkPosition[];
  x: number;
  tipY: number;
  baseY: number;
}

export const resolveTimePanelMarkGroupAlarmStatus = (positions: readonly ITimePanelMarkPosition[]): number =>
  positions.reduce(
    (status, position) => {
      if (status === 255) return position.mark.alarmStatus;
      if (position.mark.alarmStatus === 255) return status;

      return Math.max(status, position.mark.alarmStatus);
    },
    positions[0]?.mark.alarmStatus ?? 0,
  );

export const groupTimePanelMarks = (
  positions: readonly ITimePanelMarkPosition[],
  spacing: number,
): ITimePanelMarkGroup[] => {
  const groups: ITimePanelMarkGroup[] = [];
  const rows = new Map<number, ITimePanelMarkGroup>();

  [...positions]
    .sort((left, right) => left.x - right.x)
    .forEach(position => {
      const previous = rows.get(position.tipY);

      if (previous && position.x - previous.x < spacing && position.baseY === previous.baseY) {
        previous.positions.push(position);
        return;
      }

      const group = {
        positions: [position],
        x: position.x,
        tipY: position.tipY,
        baseY: position.baseY,
      };
      groups.push(group);
      rows.set(position.tipY, group);
    });

  return groups;
};
